/*
 * @Author: your name
 * @Date: 2021-04-27 11:00:25
 * @LastEditTime: 2022-09-22 17:58:38
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\reserve\router.js
 */
const routes = [{
  path: '/reserve',
  name: 'reserve',
  component: () => import('@/modules/reserve/Main'),
  meta: {
    requireAuth: true
  },
  children: [
    // 预案配置
    {
      path: 'reserveplan',
      name: 'ReservePlan',
      component: () => import('@/modules/reserve/view/reserveSet'),
      meta: {
        requireAuth: false,
        routerAlive: true
      }
    },
    // 预案执行
    {
      path: 'reserveProcess',
      name: 'reserveProcess',
      component: () => import('@/modules/reserve/view/reserveProcessNew'),
      meta: {
        requireAuth: true,
        module: "reserveImplement"
      }
    },

  ]
}]


export default routes
